<div class="date-picker-container">
  <mat-form-field appearance="fill">
    <ng-container *ngIf="fromMon2Fri || isOnlyMonday || isOnlyFriday; else withoutFilter">
      <input
        *ngIf="formCtrl"
        matInput
        [formControl]="formCtrl"
        [placeholder]="placeholder"
        (dateChange)="changeDay($event)"
        [readonly]="disabled"
        [min]="(isTodayMinDate && todayDate) || (isNextWeekMinDate && nextWeekDate) || minDate"
        [max]="maxDate ? maxDate : isTwoWeeksMaxDate ? twoWeeksDate : null"
        [matDatepickerFilter]="fromMon2Fri ? onlyMon2Fri : isOnlyMonday ? onlyMonday : onlyFriday"
        [matDatepicker]="dpFormCtrl"
      />
      <mat-datepicker #dpFormCtrl></mat-datepicker>

      <input
        *ngIf="!formCtrl"
        matInput
        [(ngModel)]="day"
        [placeholder]="placeholder"
        (dateChange)="changeDay($event)"
        [readonly]="disabled"
        [min]="(isTodayMinDate && todayDate) || (isNextWeekMinDate && nextWeekDate) || minDate"
        [max]="maxDate ? maxDate : isTwoWeeksMaxDate ? twoWeeksDate : null"
        [matDatepickerFilter]="fromMon2Fri ? onlyMon2Fri : isOnlyMonday ? onlyMonday : onlyFriday"
        [matDatepicker]="dpNgModel"
      />
      <mat-datepicker #dpNgModel></mat-datepicker>
    </ng-container>

    <ng-template #withoutFilter>
      <input
        *ngIf="formCtrl"
        matInput
        [formControl]="formCtrl"
        [placeholder]="placeholder"
        (dateChange)="changeDay($event)"
        [readonly]="disabled"
        [min]="(isTodayMinDate && todayDate) || (isNextWeekMinDate && nextWeekDate) || minDate"
        [max]="maxDate ? maxDate : isTwoWeeksMaxDate ? twoWeeksDate : null"
        [matDatepicker]="dpNoFilterFormCtrl"
      />
      <mat-datepicker #dpNoFilterFormCtrl></mat-datepicker>

      <input
        *ngIf="!formCtrl"
        matInput
        [(ngModel)]="day"
        [placeholder]="placeholder"
        (dateChange)="changeDay($event)"
        [readonly]="disabled"
        [min]="(isTodayMinDate && todayDate) || (isNextWeekMinDate && nextWeekDate) || minDate"
        [max]="maxDate ? maxDate : isTwoWeeksMaxDate ? twoWeeksDate : null"
        [matDatepicker]="dpNoFilterNgModel"
      />
      <mat-datepicker #dpNoFilterNgModel></mat-datepicker>
    </ng-template>

    <mat-icon
      aria-hidden="false"
      class="calendar"
      [class.disabled]="disabled || (formCtrl && formCtrl.disabled)"
      (click)="!disabled && (!formCtrl || !formCtrl.disabled) ? openPicker() : null"
    >
      today
    </mat-icon>
  </mat-form-field>
</div>
